module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro--chf@2-60103900eb35ae38e59130b65cba3303.jpg";